"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReadyLayer = void 0;
const FixRatioContainer_1 = require("../Common/FixRatioContainer");
const InfoSprite_1 = require("../Common/InfoObject/InfoSprite");
const InfoType_1 = require("../Common/InfoObject/InfoType");
const pixi_js_1 = require("pixi.js");
const inversify_1 = require("inversify");
const Constants_1 = require("../Core/Constants");
const SymbolClasses_1 = require("../Utils/SymbolClasses");
const GameConfig_1 = require("../Core/GameConfig");
let ReadyLayer = class ReadyLayer extends FixRatioContainer_1.FixRatioContainer {
    constructor(resources, loadcfg, events) {
        super(Constants_1.LayerWidth, Constants_1.LayerHeight);
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        this.start = (auto = false) => {
            /** */
        };
        this.resize(...events.Resize.prevArgs);
        events.Resize.add((remove, w, h) => {
            if (!this.parent)
                return remove();
            this.resize(w, h);
        });
        const info = resources.ui.data.info.ready;
        const textures = resources.ui.textures;
        if (info.other instanceof Array) {
            for (const x of info.other) {
                this.addChild(new InfoSprite_1.InfoSprite(x, textures));
            }
        }
        const playbtn = new InfoSprite_1.InfoSprite(info.play, textures);
        this.addChild(playbtn);
        const autobtn = new InfoSprite_1.InfoSprite(info.auto, textures);
        this.addChild(autobtn);
        if (info.name) {
            const name = new pixi_js_1.Text(loadcfg.songName, info.name.style);
            InfoType_1.setPositionInfo(name, info.name.position);
            this.addChild(name);
        }
        playbtn.interactive = true;
        //        playbtn.buttonMode = true
        autobtn.interactive = true;
        //        autobtn.buttonMode = true
        playbtn.once("pointertap", () => this.start());
        autobtn.once("pointertap", () => this.start(true));
        events.Update.add((remove, dt) => {
            if (!this.parent)
                return remove();
            for (const x of this.children) {
                if (x instanceof InfoSprite_1.InfoSprite) {
                    x.update(dt);
                }
            }
        });
    }
};
ReadyLayer = __decorate([
    inversify_1.injectable(),
    __metadata("design:paramtypes", [SymbolClasses_1.Resources, GameConfig_1.GameLoadConfig, SymbolClasses_1.GlobalEvents])
], ReadyLayer);
exports.ReadyLayer = ReadyLayer;
//# sourceMappingURL=ReadyLayer.js.map